module.exports = "query GetStorefront($slug: String!) {\n  user(storefrontSlug: $slug) {\n    ...SponsorFragment\n  }\n}\n"